export default {
  metadata: {
    version: '1.0.0',
    id: 'textarea-1.0.0',
    name: 'JDSTextarea',
    description:
      'A Textarea lets a user input a longer amount of text than an input field, typically spanning across multiple lines.',
    usage:
      'Use a textarea when the input being expected is likely to extend beyond one line.'
  },
  hierarchy: {
    container: [
      {
        'field-container': [
          'input_label-jds-text',
          {
            'input-container': ['input']
          }
        ]
      },
      {
        'active-line-container': ['feedback-container']
      },
      'jds_feedback_block',
      'helper-jds-text'
    ]
  },
  base: {
    container: {
      'flex-direction': '{t_0}',
      'justify-content': '{t_1}',
      'align-items': '{t_2}',
      gap: '{t_3}',
      width: '{t_4}',
      opacity: '{t_42}',
      behavior: {
        hover: {}
      }
    },
    'field-container': {
      'flex-direction': '{t_5}',
      width: '{t_6}',
      'padding-bottom': '{t_7}',
      'justify-content': '{t_8}',
      'align-items': '{t_9}'
    },
    'input-container': {
      'flex-direction': '{t_10}',
      'justify-content': '{t_11}',
      width: '{t_12}',
      'padding-top': 20,
      'align-items': '{t_13}',
      'z-index': 0
    },
    input: {
      disabled: false,
      type: 'textarea',
      flex: 1,
      'text-align': '{t_14}',
      'placeholder-color': '{t_15}',
      'placeholder-font-family': '{t_16}',
      'placeholder-font-size': '{t_17}',
      'placeholder-line-height': '{t_18}',
      'placeholder-letter-spacing': '{t_19}',
      'placeholder-font-weight': '{t_20}',
      'input-color': '{t_21}',
      'input-font-family': '{t_22}',
      'input-font-size': '{t_23}',
      'input-line-height': '{t_24}',
      'input-letter-spacing': '{t_25}',
      'input-font-weight': '{t_26}',
      'resize-color': '{t_27}',
      'cursor-color': '{t_28}',
      width: '{t_29}',
      behavior: {
        hover: {
          'resize-color': '{t_30}'
        },
        focus: {
          'resize-color': '{t_31}'
        },
        active: {
          'resize-color': '{t_32}'
        }
      }
    },
    'active-line-container': {
      'flex-direction': '{t_33}',
      width: '{t_34}',
      'align-items': '{t_35}',
      'padding-top': 1,
      'padding-bottom': 1
    },
    'feedback-container': {
      width: '{t_36}',
      height: 2,
      'background-color': '{t_37}',
      'border-radius': 48,
      show: true,
      behavior: {
        hover: {
          'background-color': '{t_38}'
        },
        focus: {
          'background-color': '{t_39}'
        },
        active: {
          'background-color': '{t_40}'
        }
      }
    },
    jds_feedback_block: {
      size: 's',
      state: 'none'
    },
    'input_label-jds-text': {
      'font-family': '{text_132}',
      color: '{text_21}',
      'font-size': '{text_131}',
      'line-height': '{text_133}',
      'letter-spacing': '{text_134}',
      'font-weight': '{text_135}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      'max-lines': 1,
      textType: 'label',
      maxLines: 1,
      'z-index': 1
    },
    'helper-jds-text': {
      'font-family': '{text_147}',
      color: '{text_21}',
      'font-size': '{text_146}',
      'line-height': '{text_148}',
      'letter-spacing': '{text_149}',
      'font-weight': '{text_150}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}'
    }
  },
  variant: {
    disabled: {
      true: {
        container: {
          opacity: '{t_41}'
        },
        input: {
          disabled: true
        }
      }
    },
    state: {
      success: {
        'feedback-container': {
          'background-color': '{t_43}',
          behavior: {
            hover: {
              'background-color': '{t_44}'
            },
            focus: {
              'background-color': '{t_45}'
            },
            active: {
              'background-color': '{t_46}'
            }
          }
        },
        input: {
          'resize-color': '{t_47}',
          behavior: {
            hover: {
              'resize-color': '{t_48}'
            },
            focus: {
              'resize-color': '{t_49}'
            },
            active: {
              'resize-color': '{t_50}'
            }
          }
        },
        jds_feedback_block: {
          state: 'success'
        }
      },
      error: {
        'feedback-container': {
          'background-color': '{t_51}',
          behavior: {
            hover: {
              'background-color': '{t_52}'
            },
            focus: {
              'background-color': '{t_53}'
            },
            active: {
              'background-color': '{t_54}'
            }
          }
        },
        input: {
          'resize-color': '{t_55}',
          behavior: {
            hover: {
              'resize-color': '{t_56}'
            },
            focus: {
              'resize-color': '{t_57}'
            },
            active: {
              'resize-color': '{t_58}'
            }
          }
        },
        jds_feedback_block: {
          state: 'error'
        }
      },
      warning: {
        'feedback-container': {
          'background-color': '{t_59}',
          behavior: {
            hover: {
              'background-color': '{t_60}'
            },
            focus: {
              'background-color': '{t_61}'
            },
            active: {
              'background-color': '{t_62}'
            }
          }
        },
        input: {
          'resize-color': '{t_63}',
          behavior: {
            hover: {
              'resize-color': '{t_64}'
            },
            focus: {
              'resize-color': '{t_65}'
            },
            active: {
              'resize-color': '{t_66}'
            }
          }
        },
        jds_feedback_block: {
          state: 'warning'
        }
      }
    },
    _labelFocus: {
      true: {
        'field-container': {
          'align-items': '{t_67}'
        },
        'input_label-jds-text': {
          'font-family': '{text_147}',
          'font-size': '{text_146}',
          'line-height': '{text_148}',
          'letter-spacing': '{text_149}',
          'font-weight': '{text_150}',
          'padding-top': 0
        }
      }
    }
  },
  combination: [
    {
      none: {
        true: {
          'feedback-container': {
            'background-color': '{t_68}'
          },
          input: {
            'resize-color': '{t_69}'
          }
        }
      }
    }
  ],
  combination_config: [['state', '_inputFocus']],
  api: {
    config: {
      disabled: {
        values: [false, true],
        doc_description: 'It can be used to enable or disable SearchBox.'
      },
      state: {
        type: 'JDSFeedbackBlock.state',
        doc_description:
          "It can be used to choose between states i.e. 'success','warning','error','none'.",
        values: ['none', 'success', 'error', 'warning']
      },
      _labelFocus: {
        values: [false, true]
      },
      _inputFocus: {
        values: [false, true]
      }
    },
    data: {
      input: {
        id: {
          type: 'string',
          name: 'id',
          platform: 'web'
        },
        name: {
          type: 'string',
          name: 'name'
        },
        value: {
          type: 'string',
          name: 'value'
        },
        rows: {
          type: 'number',
          name: 'rows'
        },
        placeholder: {
          type: 'string',
          name: 'placeholder'
        },
        'max-length': {
          type: 'number',
          name: 'maxLength'
        },
        required: {
          type: 'boolean',
          name: 'required'
        },
        focusRequester: {
          type: 'focusRequester',
          name: 'focusRequester',
          platform: 'android'
        },
        imeAction: {
          type: 'imeAction',
          name: 'imeAction',
          platform: 'android'
        },
        capitalization: {
          type: 'keyboardCapitalization',
          name: 'capitalization',
          platform: 'android'
        },
        semantics: {
          type: 'string',
          name: 'semantics',
          platform: 'android'
        }
      },
      jds_feedback_block: {
        stateText: {
          type: 'string',
          name: 'stateText',
          doc_description:
            'It displays message with respect to its [state] selected.'
        }
      },
      'input_label-jds-text': {
        value: {
          type: 'string',
          name: 'label',
          doc_description: 'It displays label of Textarea.'
        },
        id: {
          type: 'string',
          name: 'id',
          platform: 'web'
        }
      },
      'helper-jds-text': {
        value: {
          type: 'string',
          name: 'helperText',
          doc_description: 'It displays helper text of Textarea.'
        }
      }
    },
    events: {
      input: {
        onFocus: 'onFocus',
        onBlur: 'onBlur',
        onChange: 'onChange',
        onKeydown: {
          name: 'onKeydown',
          platform: 'web'
        },
        onInvalid: 'onInvalid',
        onSubmit: 'onSubmit'
      }
    },
    a11y: {
      input: {
        properties: {
          'aria-label': {
            name: 'ariaLabel',
            prop: 'label'
          },
          'aria-describedby': {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          },
          'aria-invalid': 'ariaInvalid',
          'aria-placeholder': {
            name: '_ariaPlaceholder',
            prop: 'placeholder'
          },
          'aria-required': {
            name: '_ariaRequired',
            prop: 'required'
          }
        }
      }
    }
  }
};
